import React, { useState, forwardRef, useImperativeHandle } from "react";

const CustomiseModal = forwardRef(({ onSubmit }, ref) => {
  const [value, setValue] = useState("");
  const [itemID, setItemID] = useState("");
  const [modalVisible, setModalVisible] = useState(false);

  const handleClose = () => {
    setModalVisible(false);
    setItemID("");
    setValue("");
  };

  const handleSubmit = () => {
    onSubmit(itemID, value);
    handleClose();
  };

  useImperativeHandle(ref, () => ({
    showDialog(itemId, request) {
      setModalVisible(true);
      setValue(request ?? "");
      setItemID(itemId ?? "");
    },
  }));

  if (!modalVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative">
        {/* Close button */}
        <button
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800"
          onClick={handleClose}
        >
          ✕
        </button>

        {/* Title */}
        <h2 className="text-lg font-semibold text-center mb-4">Customise</h2>

        {/* Input */}
        <input
          type="text"
          className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          placeholder="Enter request"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />

        {/* Buttons */}
        <div className="mt-6 flex gap-4 justify-center">
          <button
            onClick={handleClose}
            className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
});

export default CustomiseModal;
